import { Checkbox, Field, NumericInput } from '../../../../Core';
import { FieldSet, ListFieldSection } from '../../../../Layout';
import { useSelector } from 'react-redux';
import { IWorksheetComponent } from '../../../Core/types';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { pipe } from 'Lib/Hooks/Selectors';
import { QestlabListDropdown } from 'Components/List';
import ListType from 'Components/List/QestlabListDropdown/ListType';
import { valueOrDefault } from 'Lib/Any';

let PreparationSectionBase = ({ createWorksheetSelector }: IWorksheetComponent): JSX.Element => {
  const isExcavationTest = useSelector(pipe(createWorksheetSelector!('IsExcavationTest'), valueOrDefault(false)));
  const isLayerThicknessUnvailable = useSelector(
    pipe(createWorksheetSelector!('LayerThicknessUnavailable'), valueOrDefault(false))
  );

  const isDepthOfTestUnvailable = useSelector(
    pipe(createWorksheetSelector!('DepthOfTestUnavailable'), valueOrDefault(false))
  );
  return (
    <>
      <ListFieldSection>
        <Field input={<QestlabListDropdown />} name="Weather" listType={ListType.Weather} maxLength={50} />
        <Field input={<NumericInput />} name="MinimumAirTemperature" />
        <Field input={<NumericInput />} name="MaximumAirTemperature" />
        <Field input={<NumericInput />} name="MaxRequiredPressure" />
        <FieldSet>
          <Field input={<NumericInput />} name="LayerThickness" disabled={isLayerThicknessUnvailable} />
          <Field input={<Checkbox />} name="LayerThicknessUnavailable" />
        </FieldSet>
        <FieldSet>
          <Field input={<NumericInput />} name="DepthOfTest" disabled={isDepthOfTestUnvailable} />
          <Field input={<Checkbox />} name="DepthOfTestUnavailable" />
        </FieldSet>
        <Field input={<NumericInput />} name="SeatingLoad" />
        <FieldSet>
          <Field input={<Checkbox />} name="IsExcavationTest" />
          <Field input={<NumericInput />} name="PlateEdgeToWallDistance" visible={isExcavationTest} />
        </FieldSet>
      </ListFieldSection>
    </>
  );
};

const PreparationSection = withInjectedProps(PreparationSectionBase);
export { PreparationSection };
export default PreparationSection;
